import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  MaintenancePayload,
  MaintenanceService,
  STATUS_ENDPOINT_PATH,
  isMaintenanceResponse,
} from '../services/maintenance/maintenance.service';

/**
 * Routes the app to the maintenance page when the backend answers with its maintenance
 * 503 (`{ status: 'maintenance', ... }`). The error is rethrown so callers keep their own
 * handling; a plain 503 without that body is left alone (transient outage, not maintenance).
 */
@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {
  private readonly maintenanceService: MaintenanceService = inject(MaintenanceService);
  private readonly router: Router = inject(Router);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.url.includes(STATUS_ENDPOINT_PATH)) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      catchError((error: unknown) => {
        if (isMaintenanceResponse(error)) {
          const payload: MaintenancePayload = error.error as MaintenancePayload;
          this.maintenanceService.enter(payload, this.router.url);
        }
        return throwError(() => error);
      }),
    );
  }
}
